export default __webpack_public_path__ + "static/joko-app-screenshot-home-3-en-8bc460962cfa64610ceaa8fbc57a27aa.png";